// extracted by mini-css-extract-plugin
export default {"primary-light":"rgba(122, 234, 110, 1)","flex-center":"theme_flex-center__gQJzG","ml10":"theme_ml10__eYZsk"};